<template>
  <div>

    <div id="customer-account-limit-request-table" class="vx-row">

      <div v-if="account_type !== 'proforma' || account_limit_requests.length > 0" class="vx-col w-full">
        <vx-card v-can="'view-account-limit-request'" title="ACCOUNT LIMIT REQUESTS">
          <template slot="actions">
            <vs-button v-can="'create-edit-account-limit-request'"  v-if="account_type !== 'proforma'"
              @click="onClickCreateSite" class="mr-4" color="primary" type="filled">Create a credit request
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" :data="account_limit_requests"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="thead">
                <vs-th width="10%" sort-key="change_to">DATE</vs-th>
                <vs-th width="10%" sort-key="created_by">CREATED BY</vs-th>
                <vs-th width="10%" sort-key="created_by">VALID TILL</vs-th>
                <vs-th width="10%" sort-key="change_to">CREDIT AMOUNT REQUESTED ({{account_currency}})</vs-th>
                <vs-th width="10%" sort-key="note">NOTE</vs-th>
                <vs-th width="10%" sort-key="reason_for_change">REASON FOR CHANGE</vs-th>
                <vs-th width="10%" sort-key="status">STATUS</vs-th>
                <vs-th width="10%">PROCESSED BY</vs-th>
                <vs-th width="10%" sort-key="status_reason">STATUS REASON</vs-th>
                <vs-th v-if="account_type !== 'proforma'" width="10%" v-can="'create-edit-account-limit-request'" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by}}
                  </vs-td>

                  <vs-td :data="data[indextr].valid_till">
                    {{ data[indextr].valid_till || 'N/A'}}
                  </vs-td>

                  <vs-td :data="data[indextr].change_to">
                    {{ data[indextr].change_to}}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    {{ data[indextr].note}}
                  </vs-td>

                  <vs-td :data="data[indextr].reason_for_change">
                    {{ data[indextr].reason_for_change}}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="creditRequestColorFactory(data[indextr].status)">
                      {{ data[indextr].status }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].approved_by_staff">
                    {{ data[indextr].approved_by_staff}}
                  </vs-td>

                  <vs-td :data="data[indextr].status_reason">
                    {{ data[indextr].status_reason}}
                  </vs-td>

                  <vs-td v-if="account_type !== 'proforma'" v-can="'create-edit-account-limit-request'">
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View/Update" position="left">
                        <vs-button @click.native="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Pending'].includes(data[indextr].status)" class="ml-2" text="Approve" position="left">
                        <vs-button @click.native="onClickStatusChange(data[indextr].id, 'approve')"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Pending','Approved'].includes(data[indextr].status)" class="ml-2" text="Reject" position="left">
                        <vs-button @click.native="onClickStatusChange(data[indextr].id, 'reject')"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination v-can="'view-account-limit-request'" :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      @cancel="status_change_obj={}"
      @accept="changeLimitRequestStatus"
      @close="activePrompt = false"
      :is-valid="isValidReason"
      :title="status_change_obj.status === 'approve' ? 'Approve Limit Request' : 'Reject Limit Request'"
      :accept-text="status_change_obj.status === 'approve' ? 'Approve' : 'Reject'"
      :color="status_change_obj.status === 'approve' ? 'primary' : 'danger'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <span>Status change reason</span>
            <vs-input v-model="status_change_obj.status_reason" class="mt-3 w-full" />
          </div>
        </div>
        <div class="vx-row mb-3" v-if="status_change_obj.status === 'approve'">
          <div class="vx-col w-full">
            <span>Valid until</span>
            <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="status_change_obj.valid_till"
                        placeholder="Choose Date"/>
          </div>
        </div>
      </div>
    </vs-prompt>

    <create-customer-account-limit-request-pop-up v-bind:account_currency="account_currency" ref="createCustomerAccountLimitRequestPopUp"/>
    <update-customer-account-limit-request-pop-up v-bind:account_currency="account_currency" ref="updateCustomerAccountLimitRequestPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import UpdateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/UpdateCustomerAccountLimitRequestPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'AllUsersList',
    props: {
      account_currency  : {
        type: String,
        default: '',
      },
      account_type: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        account_limit_requests: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        status_change_obj: {},
        activePrompt: false
      }
    },
    components: {
      'v-select': vSelect,
      flatPickr,
      CreateCustomerAccountLimitRequestPopUp,
      UpdateCustomerAccountLimitRequestPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
    },
    methods: {
      async refreshData () {
        this.fetchAccountLimitRequests()
      },

      async fetchAccountLimitRequests() {
        await this.$vs.loading({
          container: '#customer-account-limit-request-table',
          scale: 0.45
        })
        const {data} = await CustomerRepository.getAccountLimitRequestList(this.customerId, this.page)
        this.account_limit_requests =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#customer-account-limit-request-table > .con-vs-loading')
      },

      async onClickCreateSite () {
        await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.customerId)
      },
      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerAccountLimitRequestPopUp.openPopup(id)
      },

      filterQueryUpdate (){
        this.fetchAccountLimitRequests()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchAccountLimitRequests()
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return 'danger';
        }
      },
      onClickStatusChange(id, status) {
        this.status_change_obj.status = status
        this.status_change_obj.id = id
        this.activePrompt =  true
      },
      async changeLimitRequestStatus() {
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.statusChangeAccountLimitRequest(
            this.status_change_obj.id,
            {status_reason: this.status_change_obj.status_reason, valid_till: this.status_change_obj.valid_till} ,
            this.status_change_obj.status
          )
          this.status_change_obj.status_reason = null
          this.status_change_obj.valid_till = null
          await this.fetchAccountLimitRequests()
          if (this.status_change_obj.status === 'approve') {
            this.$emit('creditApproved')
          }
          this.showSuccessMessage('Status changed successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      creditRequestColorFactory(status_name) {
        switch (status_name) {
          case 'Approved':
            return 'primary';
          case 'Rejected' :
            return 'danger';
          case 'Pending':
            return 'warning'
        }
      }
    },
    watch : {
      page(){
        this.fetchAccountLimitRequests()
      }
    },
    computed: {
      isValidReason() {
        if (!this.status_change_obj.status_reason){
          return false
        }
        return this.status_change_obj.status_reason.length > 2;
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
